import React from 'react'
import HomeBanner from './HomeBanner'
import HomeHeader from './HomeHeader'

export default function Home() {

  return (
    <>
      <HomeHeader />
      <HomeBanner />
    </>
  )
}
